type StepHeadingProps = {
  /** 1'den başlayan adım numarası; başlıkta "N. ADIM" olarak yazılır. */
  stepNumber: number;
  title: string;
  description?: string;
};

/** Adım kartının üst başlığı: küçük adım etiketi + büyük soru + açıklama. */
const StepHeading = ({ stepNumber, title, description }: StepHeadingProps) => (
  <div className="space-y-2">
    <p className="text-primary text-sm font-bold tracking-[0.12em] uppercase">
      {stepNumber}. Adım
    </p>
    <h1 className="text-2xl font-bold tracking-tight text-gray-900 md:text-[1.75rem] xl:text-[2.25rem]">
      {title}
    </h1>
    {description && (
      <p className="text-base text-gray-600 md:text-[15px] xl:text-lg">
        {description}
      </p>
    )}
  </div>
);

export default StepHeading;
